<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap.scss';
@import 'node_modules/bootstrap-vue/src/index.scss';
@import "./assets/css/defaults.css";
</style>

<script>
import {mapActions} from "vuex";


export default {
  name: "App",
  mounted() {
    this.init_auth()
  },
  methods: {
    ...mapActions({
      init_auth: "auth/init_auth"
    })
  }
}

</script>